import { isValue } from '@shared/fondof-fn/validation/value'
import type { Attributes } from '@shared/shop-api/attributes/types'
import type {
  AttributeFragment,
  AttributeInput,
} from '@shared/types/storefront/graphql'

export const toAttributes = <TAttributes extends Attributes>(
  attributes: AttributeFragment[]
) => {
  return attributes.reduce((attributes, attribute) => {
    return {
      ...attributes,
      [attribute.key]: attribute.value
        ? JSON.parse(attribute.value)
        : attribute.value,
    }
  }, {}) as TAttributes
}

export const toAttributesInput = (
  attributes: Attributes,
  type = 'JSON'
): AttributeInput[] => {
  return Object.entries(attributes)
    .map(([key, value]) => ({
      key,
      value: type === 'JSON' ? JSON.stringify(value) : (value as string),
    }))
    .filter((attributeInput) => isValue(attributeInput.value))
}
